const OPERATION_ID_PATTERN = /^op_[0-9a-f]{32}$/;

export function isAccountOperationId(value) {
  return typeof value === "string" && OPERATION_ID_PATTERN.test(value);
}

export function createAccountOperationId(cryptoRef = globalThis.crypto) {
  if (typeof cryptoRef?.randomUUID === "function") {
    return `op_${cryptoRef.randomUUID().replaceAll("-", "").toLowerCase()}`;
  }
  if (typeof cryptoRef?.getRandomValues === "function") {
    const bytes = new Uint8Array(16);
    cryptoRef.getRandomValues(bytes);
    return `op_${Array.from(bytes, (value) =>
      value.toString(16).padStart(2, "0")).join("")}`;
  }
  throw new TypeError("Secure operation identity generation is unavailable.");
}
